module.exports = __webpack_public_path__ + "img/icon-bin-light.1fb01cf0.svg";